import Panel from './panel.component';
export default Panel;
